import { type UserOutFull, refKeys, usersApi } from '@/features/references/api'
import { typedSuspenseOptions } from '@/lib/query/typed-suspense-query'

export const usersListQuery = () =>
  typedSuspenseOptions<readonly UserOutFull[]>({
    queryKey: refKeys.users(),
    queryFn: ({ signal }) => usersApi.list(signal),
    staleTime: 30_000,
  })
